import { TAlert } from '../utils/types';
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

const defaultAlertTimeSuccess = 5000;
const defaultAlertTimeError = 10000;

const initialState: TAlert[] = [];

export const alertSlice = createSlice({
  name: 'alertSlice',
  initialState,
  reducers: {
    showAlert: (state, action: PayloadAction<TAlert>) => {
      const newState = [...state];
      newState.push({
        id: uuidv4(),
        alertTime:
          action.payload.severity === 'error' ||
          action.payload.severity === 'warning'
            ? defaultAlertTimeError
            : defaultAlertTimeSuccess,
        ...action.payload,
      });
      return newState;
    },
    removeAlert: (state, action: PayloadAction<string>) => {
      return state.filter(
        (alert) => alert.id !== action.payload
      );
    },
  },
});

export const { showAlert, removeAlert } =
  alertSlice.actions;

export default alertSlice.reducer;
